
























































import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator'
import {Base} from '@/base';

@Component({
  name: 'TheTable'
})
export default class TheTable extends Base{
  @Prop({default: ''}) titleText;
  @Prop({default: ''}) titleBg;
  @Prop({default: () => ([])}) columns: any;
  @Prop({default: () => ([])}) rows: any;
  @Prop({default: ''}) sorted;
  @Prop({default: ''}) sortedDir;
  @Prop({default: false}) pagination;
  @Prop({default: 30}) perPage;
  @Prop({default: false}) isShow;
  @Prop({default: ''}) trackBy;

  currentSort = this.sorted;
  currentSortDir = this.sortedDir;
  currentPage = 1;
  // Computed
  get sortedRows() {
    if (!this.rows) return 0;

    const rows = [
      ...this.rows.sort((a, b) => {
        const row1 =
                typeof a[this.currentSort] === 'string'
                        ? +a[this.currentSort].replace(/,/g, '')
                        : a[this.currentSort];
        const row2 =
                typeof b[this.currentSort] === 'string'
                        ? +b[this.currentSort].replace(/,/g, '')
                        : b[this.currentSort];
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (row1 < row2) return -1 * modifier;
        if (row1 > row2) return modifier;
        return 0;
      })
    ];
    return this.pagination ? this.paginate(rows) : rows;
  }
  // Methods
  sort(s) {
    //if s == current sort, reverse
    if (s === this.currentSort) {this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      return;
    }
    this.currentSort = s;
    this.currentSortDir = 'asc';
  }
  paginate(rows) {
    return rows.splice((this.currentPage - 1) * this.perPage, this.perPage);
  }
}
